import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import scrollbar from './foundations/scrollbar';
import getDefaultTransitionProps from './utils/getDefaultTransitionProps';

const global = (props: StyleFunctionProps) => ({
  body: {
    bg: mode('#F5F5F5', 'neutral.surface')(props),
    ...getDefaultTransitionProps(),
    '-webkit-tap-highlight-color': 'transparent',
    'font-variant-ligatures': 'no-contextual',
    borderStyle: 'solid',
    borderColor: '#DEDEDE',
    borderWidth: 0,
    // overflowY: { lg: "overlay" },
    overflowY: 'scroll !important',
    color: 'neutral.element.primary',
  },
  mark: {
    bgColor: mode('green.100', 'green.800')(props),
    color: 'inherit',
  },
  'svg *::selection': {
    color: 'none',
    background: 'none',
  },
  form: {
    w: '100%',
  },
  '*, *::before, ::after': {
    borderColor: '#DEDEDE',
  },
  ...scrollbar(props),
});

export default global;
